export default "__VITE_ASSET__e9ff2682__"